import * as React from 'react';
import {Button, Form, Input} from 'antd';
import {withFirebase} from '../Firebase';
import Firebase from '../Firebase';

import {INurateFeedback} from '../../model/User';
import {FormStates} from '../FormModal/FormWrapper';

interface IProps {
  firebase: Firebase;
  form: any;
  onFormStateChange: (formState: FormStates, formMessage: string) => {}
}

const {TextArea} = Input;

class NurateFeedback extends React.Component<IProps, {}> {

  constructor(props: IProps) {
    super(props);
  }

  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: INurateFeedback) => {
      if (!err) {
        this.props.firebase.createNurateFeedback(values.message)
          .then((docRef) => {
            this.props.onFormStateChange(FormStates.success, 'Thank you for your message, +10 to your karma :)');
          })
          .catch((error) => {
            console.log(error);
            this.props.onFormStateChange(FormStates.error, 'Ups, something bad happened, please try again');
          })
      }
    });

  }

  public render() {
    const { getFieldDecorator } = this.props.form;

    return(
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item label='Your message'>
            {getFieldDecorator('message', {
              required: true, message: 'Please, enter your message'
            })(
              <TextArea rows={4} />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }

}

export default Form.create<IProps>()(withFirebase(NurateFeedback));